import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { canReachWorkOrders } from '@signalvote/shared';
import { useCampaignStore } from '@/stores';

/**
 * Layout + guard for the campaign-facing Work Orders area (ADR-068): *platform admin OR full
 * admin*. The per-campaign `workOrdersEnabled` flag gates acting on a Text send, not reaching
 * the area (ADR-090) — the jobs screen hides the Text send actions instead. Anyone else is
 * bounced to /app (not a 404), mirroring the /admin route precedent.
 */
export const Route = createFileRoute('/app/work-orders')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.user) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
    if (context.auth.user.isPlatformAdmin) return;
    const { selectedCampaign, isFullAdmin } = useCampaignStore.getState();
    // Right after sign-in no campaign is selected yet. The /app CampaignGate selects one and
    // reloads this URL, and the check below runs then; redirecting now would lose the deep link.
    if (!selectedCampaign) return;
    if (
      canReachWorkOrders({
        isPlatformAdmin: false,
        isFullAdmin: isFullAdmin(),
        workOrdersEnabled: selectedCampaign.workOrdersEnabled,
      })
    ) {
      return;
    }
    throw redirect({ to: '/app' });
  },
  component: WorkOrdersLayout,
});

function WorkOrdersLayout() {
  return <Outlet />;
}
